import React from 'react'
import '../../styles/continueModal.css'
import { useTranslator } from '../translator/hook'

type ContinueModalProps = {
  onContinue: () => void
  onNew: () => void
}

export const ContinueModal: React.FC<ContinueModalProps> = ({
  onContinue,
  onNew,
}) => {
  const { t } = useTranslator()

  return (
    <div className="continue-modal-overlay">
      <div className="continue-modal-body">
        <h2 className="continue-modal-title">{t('continue_modal_title')}</h2>

        <div className="continue-modal-buttons">
          <button
            className="continue-modal-btn continue-modal-continue-btn"
            onClick={onContinue}
          >
            {t('continue_modal_resume')}
          </button>

          <button
            className="continue-modal-btn continue-modal-new-btn"
            onClick={onNew}
          >
            {t('continue_modal_new')}
          </button>
        </div>
      </div>
    </div>
  )
}
